import { makeStyles } from '@material-ui/core'

const useSyncAccountingThankYouStyles = makeStyles((theme) => {
    return {
        thankYouWrapper: {
            display: 'flex',
            maxWidth: '1441px',
            minHeight: 'calc(100vh - 208px)',
            padding: '24px 88px',
            alignItems: 'center',
            marginBottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        thankYouBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '32px',
            width: '100%',
            maxWidth: '665px'
        },
        bannerTitle: {
            fontFamily: 'Roboto',
            lineHeight: '68px',
            color: 'var(--neutrals-grey-900, #212121)',
            fontStyle: 'normal',
            fontSize: '48px',
            fontWeight: 700,
            alignSelf: 'stretch'
        },
        heading: {
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '30px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: '40px',
            alignSelf: 'stretch'
        },
        additionalContent: {
            color: 'var(--neutrals-grey-900, #212121)',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22px',
            alignSelf: 'stretch'
        },
        trapezoidBg: {
            position: 'relative',
            // minHeight: '80vh',
            overflow: 'hidden',
            // zIndex: 1,
            '&::before': {
                content: '""',
                background: 'linear-gradient(234deg, #005C82 28.58%, #0B9EDB 99.46%)',
                position: 'absolute',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                clipPath: 'polygon(95% 0, 100% 0, 100% 100%, 37.5% 100%)'
            }
        }
    }
})

export default useSyncAccountingThankYouStyles
